import { authenticatedApi } from './api';

const API_HOME_PATH = '/main/home';

export const fetchHomePageVod = async () => authenticatedApi.get(
	`${API_HOME_PATH}/vod`,
);
